/**
 * Event Names
 */
export const REFRESH_SUBSCRIPTIONS = 'REFRESH_SUBSCRIPTIONS'
export const REFRESH_CUSTOMERS = 'REFRESH_CUSTOMERS'
export const REFRESH_APPOINTMENTS = 'REFRESH_APPOINTMENTS'
export const REFRESH_CUSTOMER = "REFRESH_CUSTOMER"
export const REFRESH_CUSTOMER_NOTES = "REFRESH_CUSTOMER_NOTES"
export const REFRESH_CUSTOMER_APPOINTMENTS = "REFRESH_CUSTOMER_APPOINTMENTS"